import {serializr, indirectReference, classConstructorParam, indirectObject, funct } from '@mecatran/serializr-extensions';
import {model, schema}  from  "@mecatran/geo-schemas";

var { setDefaultModelSchema } = serializr;


setDefaultModelSchema( model.Geojson, schema.schemaGeojson );
setDefaultModelSchema( model.Feature, schema.schemaFeature );
setDefaultModelSchema( model.Geometry, schema.schemaGeometry );
setDefaultModelSchema( model.Properties, schema.schemaProperties );

export {model}



